export default __webpack_public_path__ + "static/media/4.5f626be0.jpeg";